<template>
  <v-sheet class="my-loader d-flex justify-center align-center" rounded="0">
    <v-card class="pa-2" elevation="0" color="amber-darken-4" style="min-width: 450px" rounded="xl">
      <v-alert
          class="mb-2"
          rounded="xl"
          color="grey-lighten-4"
          :icon="['fas', 'clock']"
          prominent
      >
        <template v-slot:prepend>
          <v-icon :icon="['fas', 'clock']" />
        </template>
        Ожидайте
      </v-alert>

      <v-progress-linear height="25" indeterminate color="white" rounded="xl">
        <strong>ЗАГРУЗКА</strong>
      </v-progress-linear>
    </v-card>
  </v-sheet>
</template>

<script>

export default {
  name: "NewLoaderComponent"
}
</script>

<style scoped>
  .my-loader {
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5000;
  }
</style>
